import template from './index.jst';
import './index.styl';
import { redirectTo, Preloader } from '../../../../../core/utils';
import { CoreRegenerationRestartView } from '../../../../../core/views';

/**
 * @desc Regeneration Comp Restart View Class
 */
export default class RegenerationCompRestartView extends CoreRegenerationRestartView {
	get template() {
		return template;
	}

	regenerationLeagueSuccess() {
		Preloader.hide();
		let league_id = this.model.get( 'id' ),
			url       = `/comps/${league_id}/regenerate/invite/${this.old_league_id}`;

		redirectTo( url );
	}
}